import React, { useEffect, useState } from "react";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase";
import {
  Button,
  Modal,
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

const SymptomSelector = ({ onSelectSymptom }) => {
  const [symptoms, setSymptoms] = useState([]);
  const [open, setOpen] = useState(false);

  // Fetch symptoms from Firestore
  useEffect(() => {
    const fetchSymptoms = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "symptoms"));
        const symptomsList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setSymptoms(symptomsList);
      } catch (error) {
        console.error("Error fetching symptoms:", error);
      }
    };
    fetchSymptoms();
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Handle Symptom selection and pass both name and id
  const handleItemClick = (symptom) => {
    onSelectSymptom({ name: symptom.name, id: symptom.id });
    handleClose();
  };

  return (
    <>
      <Button variant="outlined" onClick={handleOpen} sx={{ mt: 2 }}>
        Select Symptoms
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "40%",
            bgcolor: "background.paper",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            Select a Symptom
          </Typography>
          <List sx={{ maxHeight: 200, overflowY: "auto" }}>
            {symptoms.map((symptom) => (
              <ListItem
                button
                key={symptom.id}
                onClick={() => handleItemClick(symptom)}
              >
                <ListItemText
                  primary={symptom.name}
                  secondary={symptom.description}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Modal>
    </>
  );
};

SymptomSelector.propTypes = {
  onSelectSymptom: PropTypes.func.isRequired,
};

export default SymptomSelector;
